/**
 * Nasdaq iFrame height calculation
 */
(function ($) {

    // This will resize iframe to its content's correct height when loaded
    function nasdaqFrameSizeMessageListener(e) {
        if (typeof e.data === 'string' && e.data.indexOf("iframe_height:") === 0) {
            var d = e.data.split(':'),
                iframe_height = parseInt(d[1], 10),
                iframe = document.getElementById('nasdaq_iframe_' + d[2]);

            if (iframe) {
                iframe.style.height = iframe_height + 'px';
            }
        }
    }

    if (window.addEventListener) {
        window.addEventListener("message", nasdaqFrameSizeMessageListener, false);
    } else {
        window.attachEvent("onmessage", nasdaqFrameSizeMessageListener);
    }

})(jQuery);

